import { useState, useEffect } from "react";
import "./FormQuestionTag.css";
import { iconPath, QuestionType } from "effno-core";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";

const QuestionTypeIcons = {
    [QuestionType.SHORT]: "short.svg",
    [QuestionType.LONG]: "long.svg",
    [QuestionType.EMAIL]: "email.svg",
    [QuestionType.WEBSITE]: "website.svg",
    [QuestionType.PHONE]: "phone.svg",
    [QuestionType.DATE]: "date.svg",
    [QuestionType.CONTACT]: "contact.svg",
    [QuestionType.MULTIPLE]: "multiple.svg",
    [QuestionType.FILE_UPLOAD]: "file-upload.svg",
    [QuestionType.NUMBER]: "number.svg",
    [QuestionType.NPS]: "nps.svg",
    [QuestionType.SCORE]: "score.svg",
    [QuestionType.RATING]: "rating.svg",
    [QuestionType.SECTION]: "section.svg",
    [QuestionType.END]: "end.svg",
    // [QuestionType.CHECKBOX]: "checkbox.svg",
    // [QuestionType.TIME]: "time.svg",
}

export const QuestionTypeIconColors = {
    [QuestionType.SHORT]: "#ff7f7f",
    [QuestionType.LONG]: "#ffac7f",
    [QuestionType.EMAIL]: "#ffd97f",
    [QuestionType.WEBSITE]: "#f7ff7f",
    [QuestionType.PHONE]: "#caff7f",
    [QuestionType.DATE]: "#9dff7f",
    [QuestionType.CONTACT]: "#ff7fac",
    [QuestionType.MULTIPLE]: "#7fff8e",
    [QuestionType.FILE_UPLOAD]: "#7fffbb",
    [QuestionType.NUMBER]: "#7fffe8",
    [QuestionType.NPS]: "#7fe8ff",
    [QuestionType.SCORE]: "#7fbbff",
    [QuestionType.RATING]: "#ff8ef0",
    // [QuestionType.SECTION]: "#9d7fff", 
    [QuestionType.SECTION]: "#bdabfc",
    [QuestionType.END]: "#ca7fff",
    // [QuestionType.CHECKBOX]: "#f77fff",
    // [QuestionType.TIME]: "#ff7fd9",
};

export const QuestionTypeDisplay = {
    [QuestionType.SHORT]: "Short Answer",
    [QuestionType.LONG]: "Long Answer",
    [QuestionType.EMAIL]: "Email",
    [QuestionType.WEBSITE]: "Website",
    [QuestionType.PHONE]: "Phone Number",
    [QuestionType.DATE]: "Date",
    [QuestionType.CONTACT]: "Contact Form",
    [QuestionType.MULTIPLE]: "Multiple Choice",
    [QuestionType.FILE_UPLOAD]: "File Upload",
    [QuestionType.NUMBER]: "Number",
    [QuestionType.NPS]: "NPS Score",
    [QuestionType.SCORE]: "Score",
    [QuestionType.RATING]: "Rating",
    [QuestionType.SECTION]: "Section Page",
    [QuestionType.END]: "End Page",
    // [QuestionType.CHECKBOX]: "Checkbox",
    // [QuestionType.TIME]: "Time",
}


type FormQuestionTagProps = {
    type: QuestionType;
}

export const FormQuestionTag = ({type} : FormQuestionTagProps) => {

    const storeUser = useSelector(selectUser);

    return (
        <div 
            className="form-question-tag"
            style={{backgroundColor: QuestionTypeIconColors[type]}}
        >
            <img src={iconPath("/questions/" + QuestionTypeIcons[type], storeUser)} alt={type} />
        </div>
    )
}